import Vue from 'vue';
import axios from 'axios';
import '../filters';
import moment from 'moment';
import users from '../users';

export default {
  name: 'FindCustomer',
  mixins: [users],
  components: {
    DataGridComp: require('./datagrid.vue').default,
    filterDataComp: require('./filterData.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      mainApplicationId: -1,
      appId: -1,

      keyColumn: 'customerKey',
      
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      customersCols: [],
      
      noDataFound: false
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$root.$on('find_customer_updated', this.init);
    this.fillCustomersCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;

        if (this.dataObj.customer.customerKey == '') {
          this.dataObj.showSelectedPanel = false;
        }
        else {
          this.dataObj.showSelectedPanel = true;
        }

        this.fillFiltersObj();
      });
    },
    pageChange(pInfo) {
      if (this.options.page == pInfo.pageNumber && this.options.pageSize == pInfo.pageSize)
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getCustomers();
    },
    getCustomers() {
      var criteria = {};

      for (var i = 0; i < this.dataObj.filterObj.filter(a => a.added).length; i++) {
        criteria[this.dataObj.filterObj.filter(a => a.added)[i].field] = this.dataObj.filterObj.filter(a => a.added)[i].value;
      }

      var parameter = {
        Filters: criteria,
        Options: this.options
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/OmActivityBase/GetCustomers', parameter),
        resp => {
          if (resp.status == 200) {
            if (resp.data.items.length == 0) {
              this.dataObj.customers = [];
              this.noDataFound = true;
            }
            else {
              this.dataObj.customers = resp.data.items;
              this.options.total = resp.data.itemsCount;
              this.totalRow = resp.data.itemsCount;
            }
          }
          else
            this.$alertMsg(resp.data.data.text)
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        }
      );
    },
    onSelectCustomer(info) {
      if (info.newRowIndex < 0)
        return;

      var cust = info.rows[info.newRowIndex].data;
      if ((cust === null) || (cust === undefined))
        return;

      this.dataObj.customer = cust;
    },
    applyFilter() {
      this.getCustomers();
    },
    fillCustomersCols() {
      this.customersCols.push({ dataField: 'billingGroupStr', caption: this.$t('activities.billingGroup') });
      this.customersCols.push({ dataField: 'customerKey', caption: this.$t('activities.account') });
      this.customersCols.push({ dataField: 'surname', caption: this.$t('activities.surname') });
      this.customersCols.push({ dataField: 'idNumber', caption: this.$t('activities.initial') });
      this.customersCols.push({ dataField: 'address', caption: this.$t('activities.address') });
      this.customersCols.push({ dataField: 'consumerTypeStr', caption: this.$t('activities.consumerType') });
      this.customersCols.push({ dataField: 'telephoneNumber', caption: this.$t('activities.telephoneNumber') });
      this.customersCols.push({ dataField: 'cellPhone', caption: this.$t('activities.cellPhone') });
    },
    
    fillFiltersObj() {
      if (this.dataObj.filterObj.length > 0)
        return;

      this.dataObj.filterObj.push(
        {
          defaultIndex: 0,
          index: 0,
          field: 'BillingGroup',
          fieldDesc: this.$t('activities.billingGroup'),
          type: 'list',
          listSource: this.dataObj.billingGroups? this.dataObj.billingGroups.sort((a, b) => a.value - b.value): [],
          listValueField: this.dataObj.bgValueField == false ? 'id' : 'value',
          listTextField: this.dataObj.bgTextField == false ? 'name' : 'text',
          addedDefault: true,
          defaultValue: '-1',
          value: '-1',
          added: true
        });

      //this.dataObj.filterObj.push(
      //  {
      //    defaultIndex: 1,
      //    index: 1,
      //    field: 'ConsumerType',
      //    fieldDesc: this.$t('activities.consumerType'),
      //    type: 'list',
      //    listSource: this.dataObj.consumerTypes.sort((a, b) => a.value - b.value),
      //    listValueField: 'value',
      //    listTextField: 'text',
      //    addedDefault: true,
      //    defaultValue: '-1',
      //    value: '-1',
      //    added: true
      //  });

      this.dataObj.filterObj.push(
        {
          defaultIndex: 2,
          index: 2,
          field: 'CustomerKey',
          fieldDesc: this.$t('activities.customerKey'),
          type: 'text',
          addedDefault: true,
          defaultValue: '',
          value: '',
          added: true
        });

      this.dataObj.filterObj.push({
        defaultIndex: 3,
        index: 3,
        field: 'Surname',
        fieldDesc: this.$t('activities.surname'),
        type: 'text',
        addedDefault: true,
        defaultValue: '',
        value: '',
        added: true
      });

      this.dataObj.filterObj.push({
        defaultIndex: 4,
        index: 4,
        field: 'Initial',
        fieldDesc: this.$t('activities.initial'),
        type: 'text',
        addedDefault: false,
        defaultValue: '',
        value: '',
        added: false
      });

      this.dataObj.filterObj.push({
        defaultIndex: 5,
        index: 5,
        field: 'Address',
        fieldDesc: this.$t('activities.address'),
        type: 'text',
        addedDefault: false,
        defaultValue: '',
        value: '',
        added: false
      });

      this.dataObj.filterObj.push({
        defaultIndex: 6,
        index: 6,
        field: 'TelephoneNumber',
        fieldDesc: this.$t('activities.telephoneNumber'),
        type: 'text',
        addedDefault: false,
        defaultValue: '',
        value: '',
        added: false
      });

      this.dataObj.filterObj.push({
        defaultIndex: 7,
        index: 7,
        field: 'IdNumber',
        fieldDesc: this.$t('activities.idNumber'),
        type: 'text',
        addedDefault: false,
        defaultValue: '',
        value: '',
        added: false
      });

      this.dataObj.filterObj.push({
        defaultIndex: 8,
        index: 8,
        field: 'PIN',
        fieldDesc: this.$t('activities.pin'),
        type: 'text',
        addedDefault: false,
        defaultValue: '',
        value: '',
        added: false
      });

      this.dataObj.filterObj.push({
        defaultIndex: 9,
        index: 9,
        field: 'CellPhone',
        fieldDesc: this.$t('activities.cellPhone'),
        type: 'text',
        addedDefault: false,
        defaultValue: '',
        value: '',
        added: false
      });
    }
  }
}
